// FeaturedListings.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'; // używam Link z react-router-dom
import api from '../../services/api';
import MainFeatureListing from './MainFeatureListing';
import SmallListingCard from './SmallListingCard';

const FeaturedListings = () => {
  const [featuredListings, setFeaturedListings] = useState([]);
  const [normalListings, setNormalListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchListings = async () => {
      try {
        setLoading(true);
        const response = await api.getListings();
        
        const featured = response.filter(ad => ad.featured).slice(0, 5);
        const normal = response.filter(ad => !ad.featured);

        setFeaturedListings(featured);
        setNormalListings(normal);
        setError(null);
      } catch (err) {
        setError('Nie udało się załadować ogłoszeń');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchListings();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="text-xl">Ładowanie ogłoszeń...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="text-xl text-red-600">{error}</div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 py-4 sm:py-6 md:py-8">
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-gray-800 mb-4 sm:mb-6 md:mb-8">
          OGŁOSZENIA
          <div className="w-16 sm:w-24 h-0.5 bg-[#35530A] mx-auto mt-2" />
        </h1>

        <div className="flex flex-col lg:flex-row gap-4">
          {/* Lewa strona - szersze główne wyróżnione ogłoszenie */}
          <div className="lg:w-[45%]">
            {featuredListings[0] && <MainFeatureListing listing={featuredListings[0]} />}
          </div>
          
          {/* Prawa strona - 4 mniejsze karty 2x2 */}
          <div className="lg:w-[55%]">
            <div className="grid grid-cols-2 gap-4 h-full">
              {featuredListings.slice(1, 5).map((listing) => (
                <SmallListingCard 
                  key={listing._id} 
                  listing={listing} 
                  showHotOffer={true} 
                />
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12">
          <div className="flex flex-col items-center mb-10">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
              Pozostałe ogłoszenia
            </h2>
            <div className="w-32 h-0.5 bg-[#35530A] mt-3" />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
            {normalListings.map((listing) => (
              <SmallListingCard key={listing._id} listing={listing} />
            ))}
          </div>
        </div>

        {/* Nowy przycisk na dole sekcji */}
        <div className="flex justify-center mt-8">
          <Link
            to="/listings"
            className="bg-[#35530A] text-white px-6 py-2.5 rounded-[2px] hover:bg-[#2A4208] transition-colors text-sm font-medium"
          >
            Przejdź do ogłoszeń
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FeaturedListings;
